import {createEvent, createStore} from 'effector'

//Режим гида
export const setGuideMode = createEvent<boolean>();
export const $GuideMode = createStore<boolean>(false);
$GuideMode.on(setGuideMode, (_,val)=> val);

//Подсчет слайдов на странице с фото - 
export const AddReadenPhotoSlide = createEvent();
export const clearPhotoSlides = createEvent<void>();
export const resetPhotoSlides = createEvent()
export const $ReadenPhotoSlides = createStore<number>(8);

$ReadenPhotoSlides
    .on(AddReadenPhotoSlide, (state, params) => state + 1)
    .on(clearPhotoSlides, (state, params) => 0)
    .reset(resetPhotoSlides)

//Подсчет слайдов на странице с видео - 
export const AddReadenVideoSlide = createEvent();
export const clearVideoSlides = createEvent<void>();
export const resetVideoSlides = createEvent()
export const $ReadenVideoSlides = createStore<number>(9);

$ReadenVideoSlides
    .on(AddReadenVideoSlide, (state, params) => state + 1)
    .on(clearVideoSlides, (state, params) => 0)
    .reset(resetVideoSlides)

//Подсчет слайдов на странице с 3д моделью - 
export const AddReadenModelSlide = createEvent();
export const clearModelSlides = createEvent<void>();
export const resetModelSlides = createEvent()
export const $ReadenModelSlides = createStore<number>(5);

$ReadenModelSlides
    .on(AddReadenModelSlide, (state, params) => state + 1)
    .on(clearModelSlides, (state, params) => 0)
    .reset(resetModelSlides)

//Все, что касается страницы с видео
export const setOpenVideo = createEvent<boolean>();

export const $openVideo = createStore<boolean>(true);

$openVideo.on(setOpenVideo, (state, params) => params)


//Все, что касается страницы с моделькой
export const setOpenModel = createEvent<boolean>();

export const $openModel = createStore<boolean>(true);

$openModel.on(setOpenModel, (state, params) => params)


//Правая секция
export const AddReadenSlide_RightSection = createEvent();
export const clearSlides_RightSection = createEvent<void>();
export const resetSlides_RightSection = createEvent()
export const $ReadenSlides_RightSection = createStore<number>(4);

$ReadenSlides_RightSection
    .on(AddReadenSlide_RightSection, (state, params) => state + 1)
    .on(clearSlides_RightSection, (state, params) => 0)
    .reset(resetSlides_RightSection)

//Левая секция
export const AddReadenSlide_LeftSection = createEvent();
export const clearSlides_LeftSection = createEvent<void>();
export const resetSlides_LeftSection = createEvent()
export const $ReadenSlides_LeftSection = createStore<number>(4);

$ReadenSlides_LeftSection
    .on(AddReadenSlide_LeftSection, (state, params) => state + 1)
    .on(clearSlides_LeftSection, (state, params) => 0)
    .reset(resetSlides_LeftSection)

//Все, что касается кнопки назад
export const setBackButton = createEvent<boolean>();

export const $backButton = createStore<boolean>(true);

$backButton.on(setBackButton, (state, params) => params)

//Все, что касается выбранного видео
export const setvideoChoise = createEvent<number>();

export const $videoChoise = createStore<number>(0);

$videoChoise.on(setvideoChoise, (state, params) => params)

//Все, что касается выбранной модели
export const setmodelChoise = createEvent<number>();

export const $modelChoise = createStore<number>(0);

$modelChoise.on(setmodelChoise, (state, params) => params)

//Подсчет слайдов на странице с 3д моделью Montronix-
export const AddReadenModelMonSlide = createEvent();
export const clearModelMonSlides = createEvent<void>();
export const resetModelMonSlides = createEvent()
export const $ReadenModelMonSlides = createStore<number>(5);

$ReadenModelMonSlides
    .on(AddReadenModelMonSlide, (state, params) => state + 1)
    .on(clearModelMonSlides, (state, params) => 0)
    .reset(resetModelMonSlides)

//Все, что касается страницы с моделькой Montronix
export const setOpenModelMon = createEvent<boolean>();

export const $openModelMon = createStore<boolean>(false);

$openModelMon.on(setOpenModelMon, (state, params) => params)
